/**
 * 前置条件
 * @author 3173
 * @date 2020-03-23
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer } = framework_tool;
let { WizComponent, WizCol, WizRow, WizCheckbox, WizSelect, WizIcon, WizTooltip, WizModal, WizButton } = component_tool;
import { Input, Row, Col } from 'antd'

import cloneDeep from 'lodash/cloneDeep'


import { WizTableForm } from '../../common'
const examConfig = WizTableForm.Config.exam(this, { apiParams: { status: 1 } })
const programConfig = WizTableForm.Config.program(this, { apiParams: { status: 1 } })
const surveyConfig = WizTableForm.Config.survey(this, { apiParams: { status: 1 } })

const Option = WizSelect.Option;
const pml = 20; //间距

const conditionAll = {
  program: { key: 'program', label: '课程', stateName: 'showProgram' },
  exam: { key: 'exam', label: '考试', stateName: 'showExam' },
  path: { key: 'path', label: '培训路径(暂无)', stateName: 'showPath' },
  survey: { key: 'survey', label: '问卷', stateName: 'showSurvey' }
}

const defaultCondition = {
  programCondition: [{ key: 'programDefault', entityId: null, name: '', type: 0, entityType: 0, conditionType: 0, selects: [{ key: 'programEntity', entityId: null, name: '', type: 1, entityType: 0 }] }],
  examCondition: [{ key: 'examDefault', entityId: null, name: '', type: 0, entityType: 1, conditionType: 0, selects: [{ key: 'examEntity', entityId: null, name: '', type: 1, entityType: 1 }] }],
  pathCondition:undefined,
  surveyCondition:[{ key: 'surveyDefault', entityId: null, name: '', type: 0, entityType: 3, conditionType: 0, selects: [{ key: 'surveyEntity', entityId: null, name: '', type: 1, entityType: 3 }] }],
}

export default class WizPreCondition extends WizContainer {

  componentName = 'WizPreCondition';

  constructor(props) {
    super(props);
    let _p = Object.assign({},props.value)
    let defaultCopy = cloneDeep(defaultCondition);
   
    this.state = {
      programCondition: _p.programCondition ? _p.programCondition :[...defaultCopy.programCondition],
      examCondition: _p.examCondition ?_p.examCondition :  [...defaultCopy.examCondition],
      pathCondition:undefined,
      surveyCondition: _p.surveyCondition ? _p.surveyCondition : [...defaultCopy.surveyCondition],

      showProgram: _p.programCondition ? true : false,
      showExam: _p.examCondition ? true : false,
      showPath: false,
      showSurvey: _p.surveyCondition ? true : false,

      programVisible: false,
      examVisible: false,
      pathVisible: false,
      surveyVisible: false,

      conditionArr: []
    };
    this.currentData = {};//当前选择的单个前置条件
  }

  _componentWillMount() {
    //获取需要渲染的类型
    let { showRows } = this.props;
    if (showRows && showRows instanceof Array) {
      let conditionArr = [];
      showRows.forEach(data => {
        if (conditionAll[data])
          conditionArr.push(conditionAll[data]);
      })
      this.setState({
        conditionArr: conditionArr
      })
    }
    
  }

  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      let _p = cloneDeep(nextProps.value)
      let defaultCopy = cloneDeep(defaultCondition);
      this.setState({
        programCondition:_p.programCondition ? [..._p.programCondition]: [...defaultCopy.programCondition],
        examCondition: _p.examCondition ? [..._p.examCondition] : [...defaultCopy.examCondition],
        surveyCondition: _p.surveyCondition ? [..._p.surveyCondition] : [...defaultCopy.surveyCondition],

        showProgram: _p.programCondition || this.state.showProgram ? true : false,
        showExam: _p.examCondition || this.state.showExam ? true : false,
        showSurvey: _p.surveyCondition || this.state.showSurvey ? true : false,
        receiveTime: new Date().getTime()
      });
      
      return true;
    }
  }

  propsAndStateOnChange = {
    time: this.timeChange.bind(this),
  } 

  timeChange(nextProps, nextState) {
    this._onChange()
    return true
  }

  /**值改变反馈给上层 */
  _onChange(){
    let { showRows, onChange } = this.props
    if (showRows && showRows instanceof Array) {
      let result = {};
      showRows.forEach(data => {
        let arr = this.state[data+'Condition'];
        if(arr && this.setContentOrNot(arr)){
          result[data+'Condition'] = [...arr];
        }else{
          result[data+'Condition'] = undefined;
        }
        
      })
      onChange && onChange(result)
    }
  }

  /**判断是否存在选择内容 防止点开很多层但什么都没有选*/
  setContentOrNot(list){
    let result = false;
    for (let i = 0; i < list.length; i++) {
      let data = list[i];
      if (data.type === 1 && data.entityId ) {
        result = true;
        break;
      } else if (data.type === 0) {
        if(this.setContentOrNot(data.selects)){
          result = true;
          break;
        }
      }
    }
    return result;
  }


  /**显示条件 */
  showCondition(type, checkedValues,conditionKey) {
    if (checkedValues.length > 0) {
      this.setState({ [type]: true })
    } else {
      let defaultCopy = cloneDeep(defaultCondition);
      this.setState({ 
        [type]: false ,
        [conditionKey+'Condition']: defaultCopy[conditionKey+'Condition']
      },()=>this._onChange())
    }
  }


  /**打开对应选择模态框 */
  openModal(openName, currentData) {
    this.setState({ [openName]: true })
    this.currentData = currentData;
  }


  /**获取前置条件对应数据源 */
  getConditionList(entityType, condition) {
    if (entityType == 0) {
      condition = 'programCondition';
    } else if (entityType == 1) {
      condition = 'examCondition';
    }else if(entityType == 2){
      condition = 'pathCondition';
    }else if(entityType == 3){
      condition = 'surveyCondition';
    }
    let stateCondition = this.state[condition];
    if(stateCondition==undefined){
      stateCondition = defaultCondition[condition];
    }
    return [...stateCondition];
  }

  /**条件关系改变 */
  changeCondition(currentData, val) {
    let condition = '';
    let neoCondition = this.getConditionList(currentData.entityType, condition);
    this.changeConditionFor(currentData.key, val, neoCondition);
    //
    this.setState({
      [condition]: neoCondition,
     // time: new Date().getTime()
    })
  }

  changeConditionFor(key, val, list) {
    for (let i = 0; i < list.length; i++) {
      let data = list[i];
      if (data.type === 0 && data.key === key) {
        data.conditionType = val;
        break;
      } else if (data.type === 0) {
        this.changeConditionFor(key, val, data.selects);
      }
    }
  }

  /**删除前置条件 */
  removeEntity(currentData) {
    let condition = '';
    let neoCondition = this.getConditionList(currentData.entityType, condition);
    this.removeCondition(currentData.key, neoCondition);
    if (neoCondition.length > 0 && neoCondition[0].selects && neoCondition[0].selects.length == 0) {
      neoCondition[0].selects.push({ key: currentData.entityType + new Date().getTime(), entityId: null, name: '', type: 1, entityType: currentData.entityType })
    }
    this.setState({
      [condition]: neoCondition,
      time: new Date().getTime()
    })
  }

  removeCondition(key, list) {
    let nlist = null;//需要删除元素所在的集合
    let removeIndex = 0;//需要删除的下标
    for (let i = 0; i < list.length; i++) {
      let data = list[i];
      if (data.key === key) {
        nlist = list;
        removeIndex = i;
        break;
      } else if (data.type === 0) { //继续循环里层
        this.removeCondition(key, data.selects);
      }
    }
    if (nlist != null) {
      nlist.splice(removeIndex, 1);
    }
  }

  /**添加前置条件 */
  addCondition(currentData, type) {
    let condition = '';
    let neoCondition = this.getConditionList(currentData.entityType);
    this.setNewCondition(currentData, type, neoCondition);
    this.setState({
      [condition]: neoCondition,
      time_add: new Date().getTime()
    })
  }

  setNewCondition(currentData, type, list) {
    for (let i = 0; i < list.length; i++) {
      let data = list[i];
      if (data.key === currentData.key) {
        if (type === 0) {
          data.selects.push({ key: 'type' + currentData.entityType + new Date().getTime(), entityId: null, name: '过滤分组：', type: 0, conditionType: 0, entityType: currentData.entityType, selects: [] })
        } else if (type === 1) {
          data.selects.push({ key: 'type' + currentData.entityType + new Date().getTime(), entityId: null, name: '', type: 1, entityType: currentData.entityType })
        }
        break;
      } else if (data.type === 0) { //继续循环里层
        this.setNewCondition(currentData, type, data.selects);
      }
    }
  }

  /**保存选择的数据到对应的框里 */
  saveEntity(key, visible, obj) {
    if (key && obj && obj.valueRows) {
      let entityObj = obj.valueRows[0];
      let neoCondition = [...this.state[key]];
      this.saveEntityFor(entityObj, neoCondition);

      this.setState({
        [key]: neoCondition,
        [visible]: false,
        time: new Date().getTime()
      })
    }
  }

  saveEntityFor(obj, list) {
    for (let i = 0; i < list.length; i++) {
      let data = list[i];
      if (data.type === 1 && data.key === this.currentData.key) {
        data.name = obj.name ? obj.name : obj.title ? obj.title : '';
        data.entityId = obj.id;
        break;
      } else if (data.type === 0) {
        this.saveEntityFor(obj, data.selects);
      }
    }
  }

  /**选择考试模态框 */
  examListModal() {
    return (
      <WizTableForm key={'exam' + this.state.time} ref={(r => this.examTableForm = r)} {...examConfig} selectType={'radio'} title={'选择考试'} showModal={true} visible={this.state.examVisible} onSubmit={this.saveEntity.bind(this, 'examCondition', 'examVisible')} onCancel={() => this.setState({ examVisible: false })} renderValue={() => { return null }} />
    )
  }

  /**选择课程模态框 */
  programListModal() {
    return (
      <WizTableForm key={'program' + this.state.time} {...programConfig} selectType={'radio'} title={'选择课程'} showModal={true} visible={this.state.programVisible} onSubmit={this.saveEntity.bind(this, 'programCondition', 'programVisible')} onCancel={() => this.setState({ programVisible: false })} renderValue={() => { return null }} />
    )
  }

  /**选择问卷模态框 */
  surveyListModal() {
    return (
      <WizTableForm key={'survey' + this.state.time} {...surveyConfig} selectType={'radio'} title={'选择问卷'} showModal={true} visible={this.state.surveyVisible} onSubmit={this.saveEntity.bind(this, 'surveyCondition', 'surveyVisible')} onCancel={() => this.setState({ surveyVisible: false })} renderValue={() => { return null }} />
    )
  }

  /**页面展示前置条件方法 */
  _preCondition(data, mlLength, size) {
    if (data.type === 0) {
      return (
        <>
          {this.conditionView(data, mlLength)}
          {this.preAnalysis(data.selects, mlLength + pml)}
        </>
      )
    } else if (data.type === 1) {
      return (
        <>{this.entityView(data, mlLength, size && size > 1 ? true : false)}</>
      )
    }

  }

  conditionView(data, mlLength) {
    return (
      <div style={{ marginLeft: mlLength }}>
        {data.name}条件关系
        <WizSelect defaultValue={data.conditionType} style={{ width: '10%', marginLeft: 10, }} onChange={(val) => this.changeCondition(data, val)}>
          <Option value={0}>且</Option>
          <Option value={1}>或</Option>
        </WizSelect>
        <WizButton size="small" type="primary" style={{ marginLeft: 10 }} onClick={() => this.addCondition(data, 1)}>添加条件</WizButton>
        <WizButton size="small" type="primary" style={{ marginLeft: 10, marginRight: 8 }} onClick={() => this.addCondition(data, 0)}>添加分组</WizButton>
        {
          data.key.indexOf('Default') == -1 ?
            <WizIcon key={data.key + 'icon'} className="dynamic-delete-button" type="minus-circle-o" onClick={() => this.removeEntity(data)} />
            : null
        }
      </div>
    )
  }

  entityView(data, mlLength, deleteBtn) {
    let typeName = "";
    let modalName = "";
    if (data.entityType == 0) {
      typeName = "课程";
      modalName = "programVisible";
    } else if (data.entityType == 1) {
      typeName = "考试";
      modalName = "examVisible";
    } else if (data.entityType == 2) {
      typeName = "培训";
      modalName = "pathVisible";
    } else if (data.entityType == 3) {
      typeName = "问卷";
      modalName = "surveyVisible";
    }

    let defaultValue = data.entityId ? { key: data.key, label: data.name } : undefined;
    return (
      <div style={{ marginLeft: mlLength }}>
        <span onClick={() => this.openModal(modalName, data)} style={{ marginRight: 8 }}>
          <WizSelect
            key={'wizSelect_' + data.key+new Date().getTime()}
            value={defaultValue}
            labelInValue
            open={false}
            placeholder={'请选择' + typeName}
            showArrow={false}
            onChange={(value, option) => { }}
            style={{ width: '40%' }}
          >
            {this._renderOption(data)}
          </WizSelect>
        </span>
        {
          deleteBtn ?
            <WizIcon key={data.key + 'icon'}
              className="dynamic-delete-button"
              type="minus-circle-o"
              onClick={() => this.removeEntity(data)}
            />
            : null
        }

      </div>
    )
  }

  preAnalysis(list, mlLength) {
    let rows = [];
    list && list.forEach(data => {
      rows.push(this._preCondition(data, mlLength, list.length));
    })
    return rows;
  }

  /**
   * 课程选择条件
   */
  _programCondition() {
    if (this.state.showProgram) {
      let rows = this.preAnalysis(this.state.programCondition, pml);
      return (
        <>{rows}</>
      )
    }
  }

  /**
  * 考试选择条件
  */
  _examCondition() {
    if (this.state.showExam) {
      let rows = this.preAnalysis(this.state.examCondition, pml);
      return (
        <>{rows}</>
      )
    }
  }

  _renderOptions(propsSelects) {
    if (propsSelects && propsSelects.length) {
      return propsSelects.map((row, i) => this._renderOption(row))
    }
    return null
  }

  _renderOption(row) {
    if (row) {
      return (
        <WizSelect.Option key={'option' + row['key']} value={row['name']} title={row['name']}>
          {row['name']}
        </WizSelect.Option>
      )
    }
  }

  /**单个类型显示 */
  entityRow(key, label, showKey, condition) {
    //let rows = this.preAnalysis(this.state[condition], pml);
    return (
      <>
        <Row>
          <Col>
            <WizCheckbox.Group key={key} options={[{ label: label, value: 0 }]} value={this.state[showKey] ? [0] : null} onChange={(checkedValues) => this.showCondition(showKey, checkedValues,key)} />
          </Col>
        </Row>
        {this.state[showKey]?
        this.preAnalysis(this.state[condition], pml) : null }
      </>
    )
  }

  /**所有需要显示的条件 */
  entityRows(){
    let rows = [];
    this.state.conditionArr.forEach(data=>{
      rows.push(this.entityRow(data.key,data.label,data.stateName,data.key+'Condition'))
    })
    return rows;
  }

  _render() {
    const { placeholder, ...otherProps } = this.props;
    return (
      <>
        {this.props.display ?
          <div style={{ marginLeft: 24 }}>
            {this.entityRows()}
            
          </div>
          : null}

        {this.examListModal()}
        {this.programListModal()}
        {this.surveyListModal()}
      </>
    );
  }
}


WizPreCondition.propTypes = {
  showRows: PropTypes.array, //需要显示的类型
  value: PropTypes.object, //默认值
  onChange: PropTypes.func,
  display: PropTypes.bool //是否显示 默认是
};

WizPreCondition.defaultProps = {
  showRows: [],
  value: {
  //  programCondition: [{ key: 'programDefault', entityId: null, name: '', type: 0, entityType: 0, conditionType: 0, selects: [{ key: 'programEntity', entityId: null, name: '', type: 1, entityType: 0 }] }],
  //  examCondition: [{ key: 'examDefault', entityId: null, name: '', type: 0, entityType: 1, conditionType: 0, selects: [{ key: 'examEntity', entityId: null, name: '', type: 1, entityType: 1 }] }],
  },
 
  display: true
}

